module.exports = __webpack_public_path__ + "static/media/photo37.86f839b3.jpg";